var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 133 42",
    style: {
      enableBackground: "new 0 0 173.8 60.4"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsBx: "https://boxy-svg.com",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("bxGrid", {
    x: 0,
    y: 0,
    width: 11.561,
    height: 11.561
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ffffff;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -20.299999, -9.2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "106.1,17.6 113.5,12.7 109.6,9.2 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "104.5,19.3 95,14.2 98.8,10.1 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "85.7,39.7 80.3,29.3 85.2,20.7 80,20.7 77.3,27 77.3,20.7 72.3,20.7 72.3,39.7 77.3,39.7 77.3,32.9  80.2,39.7 \t\t"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.1,24.8h-3.4V28h3v4.2h-3v3.3h3.4v4.2h-8.3v-19h8.3V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107,24.8v14.9h-5V24.8h-2.2v-4.2h9.3v4.2H107z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.4,20.7v14.9h2.8v4.2h-7.7v-19H133.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.3,39.7h-5v-19h6c2.1,0,4.2,0.5,5.5,1.8c1.3,1.3,1.7,2.8,1.7,4.9s-0.5,3.7-1.7,4.8 c-1.1,1.1-2.8,1.9-5,1.9h-1.7V39.7z M25.3,30.1H26c1.3,0,2.4-1.1,2.4-2.7c0-1.6-0.9-2.7-2.8-2.7h-0.3V30.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,20.2c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10C55.6,24.7,51.1,20.2,45.6,20.2z M45.6,35.1 c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9C50.5,32.9,48.3,35.1,45.6,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.9,35.1c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9v-5.1c-5.5,0-10,4.5-10,10s4.5,10,10,10V35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.9,39.7h5.2l-5.3-19H119h-2.1H116l-5.3,19h5.2l0.4-2.7h3.2L119.9,39.7z M116.9,33.3l1-6.2l1,6.2H116.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "153.4,39.8 148.1,29.3 153,20.7 147.8,20.7 145,27 145,20.7 140,20.7 140,39.8 145,39.8 145,33  147.9,39.8 \t\t\t"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a88a4eb215748152de0ab8e670c05117.svg";
export { ForwardRef as ReactComponent };